import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { connect } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import ModulesState from './Modules.State';
import ModulesAction from './Modules.Action';
import { withRouter } from 'kts-platform-frame/routes';
import { Field } from 'kts-scaffold-framework/utils/doc';
import { Row, Col } from 'antd';
import BillModelData from '../ModelData';
import Item from 'antd/lib/list/Item';

const { TransportModeCode } = BillModelData;
const css = require('./index.scss');

/** Redux接口 */
interface IReduxStatePart {
    
}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {

}

/** 绑定全局数据到props */
@withRouter
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({

}))
export default class UIComponents extends UIBasic<IProps, ModulesState> {

    constructor(props: IProps) {
        super(props, ModulesAction);
    }
    
    render() {
        const documentInfo = this.modulesState.despatchAdviceForm;
        return (
            <div>
                <Row>
                    
                    <Col span={5}>
                        <span className={css.titleName}>发货时间</span>
                    </Col>
                    <Col span={19}>
                        <div className={css.info}>{documentInfo.DeliveryDate && Field.formatTime(documentInfo.DeliveryDate)}</div>
                    </Col>
                </Row>
                <Row>
                    <Col span={5}>
                        <span className={css.titleName}>运输信息</span>
                    </Col>
                    <Col span={19}>
                        <div className={css.info}>
                            <div>
                                {TransportModeCode[documentInfo.TransportModeCode]}&nbsp;&nbsp;
                                {documentInfo.TransportMeansTrackingID}
                            </div>
                            <div>{documentInfo.PerformingCarrierPartyContact.Name && `${documentInfo.PerformingCarrierPartyContact.Name} | `}{documentInfo.PerformingCarrierPartyContact.Phone}</div>
                            <div>
                                {documentInfo.CarrierParty.Name}
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/display/platform/Document/DocumentDetail/UI.DespatchAdviceAddition.tsx